<template>
    <div class="home-message">
        <div v-if="messageAfterCaptureData[serviceType]">
            <template v-for="(subType,msgKeyIndex) in messageAfterCaptureData[serviceType].subTypeOrder">
                <div :key="'msgAfterCap_'+msgKeyIndex">

                    <h3 v-if="getType(subType)=='見出し'" class="my-3">
                        {{extractHomeText(messageAfterCaptureData[serviceType][subType])}}
                    </h3>
                    <v-layout row wrap v-if="getType(subType)=='本文'" class="mb-3">
                        {{extractHomeText(messageAfterCaptureData[serviceType][subType])}}
                    </v-layout>
                    <v-layout row wrap v-if="getType(subType)=='画像'" class="mb-3">
                        <v-img max-height="265"
                               contain
                               :src="messageAfterCaptureData[serviceType][subType].data"></v-img>
                    </v-layout>

                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import  { Logger } from 'aws-amplify';
    const logger = new Logger('SetDate','INFO');
    //import { AmplifyEventBus } from 'aws-amplify-vue'
    //import { uuid } from 'vue-uuid';
    //import moment from 'moment-timezone'


    export default {
        props:{
            "serviceType":{
                type:String,
                default:"adt"
            }
        },
        methods:{
            extractHomeText:function(homeDataSubObj){
                logger.info("homeDataSubObj",homeDataSubObj)
                let text = ""
                if(homeDataSubObj[this.lang]){
                    text =  homeDataSubObj[this.lang]
                }else{
                    for(let key in homeDataSubObj){
                        if(key != "data"){
                            text = homeDataSubObj[key]
                            break
                        }
                    }

                }
                // replace お店の名前
                const shopName = this.$store.state.shopName
                if(text){
                    text = text.replace(/{お店の名前}/g,shopName)
                }

                return text
            },
            getType:function(typeText){
                const textArray = typeText.split("_")
                return textArray[0]
            },
        },
        computed:{
            messageAfterCaptureData(){
                let res = {}
                if(this.$store.state.menu.messageAfterCapture
                    && this.$store.state.menu.messageAfterCapture.data
                ){
                    return this.$store.state.menu.messageAfterCapture.data
                }
                return res
            },
            lang(){
                return this.$store.state.lang
            }
        },


    }
</script>